<template>
  <v-carousel
    :show-arrows="false"
    :interval="6000"
    :cycle="true"
  >
    <v-carousel-item v-for="advertising in advertisings" :key="advertising.id">
      <div class="review-body">
        <aside>
          <div class="review-type">
            {{ advertising.transName }}
          </div>
          <div v-html="advertising.transContent"></div>
        </aside>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import CMS from '@/model/cms'

export default {
  props: {
    widget: Object
  },
  data: () => ({
    advertisings: []
  }),
  mounted() {
    CMS.getAdvertisingCarousel(this.widget.advertisingType)
      .then((response) => {
        this.advertisings = response.data
      })
      .catch((error) => {
        //@todo ошибки
      })
  }
}
</script>

<style lang="scss" scoped>
.v-carousel {
  height: auto !important;

  .review-body {
    color: white;
  }
}
</style>
